interface PageConfig {
    name: string;
    link: string;
    title: string;
}

type MobileConfigKey = 'home' | 'activities' | 'mainFilters' | 'notifications' | 'noDataFound';

export const mobileAppConfig: Record<MobileConfigKey, PageConfig> = {
    home: {
        name: 'home',
        link: 'home',
        title: 'Home',
    },
    activities: {
        name: 'activities',
        link: 'activities',
        title: 'Activities',
    },
    notifications: {
        name: 'notifications',
        link: 'notifications',
        title: 'Notifications',
    },
    mainFilters: {
        name: 'mainFilters',
        link: 'mainFilters',
        title: 'Main Filters',
    },
    noDataFound: {
        name: 'noDataFound',
        link: 'noDataFound',
        title: 'No data found',
    },
};
